import { SearchOperationBuilder, SearchParam } from 'wherecomposer/dist/SearchParam';
import { ConditionCreator } from 'wherecomposer/dist/ConditionCreator';
import { getCurrency } from '../graphql/currency';
import { Auth, API, graphqlOperation, Amplify } from 'aws-amplify';

let currencyAppSyncUrl = process.env.REACT_APP_CURRENCY_APPSYNC_URL;
let currencyApiKey = process.env.REACT_APP_CURRENCY_API_KEY;


const getCurrencyData = async () => {
    let languageGuid = localStorage.getItem('languageGuid');
    let languageCode = localStorage.getItem("languageCode");

    try {
        let lstobjSearchParam = [];
        let objSearchParam = new SearchParam();
        objSearchParam.searchParamCreate("LanguageGuid", "Guid", languageGuid, SearchOperationBuilder.create(true, false, false));
        lstobjSearchParam.push(objSearchParam);
        let objCreator = new ConditionCreator();
        let objWhere = objCreator.getSearchCondition(lstobjSearchParam);

        const currencyConfig = {
            API: {
                'graphql_endpoint': currencyAppSyncUrl,
                graphql_headers: async () => {
                    const currentSession = await Auth.currentSession();
                    return {
                        'Authorization': currentSession.getIdToken().getJwtToken(),
                        'language': languageCode,
                        'x-api-key': currencyApiKey
                    };
                }
            }
        }

        Amplify.configure(currencyConfig);

        return await API.graphql(graphqlOperation(getCurrency, { OperationList: objWhere.toJsonString() }));
    } catch (error) {
        console.log('getCurrencyData error', error);
    }


}


export {
    getCurrencyData,
}